module.exports = __webpack_public_path__ + "img/temp.2b76ef2c.png";